import { render, staticRenderFns } from "./AppExamineDetail.vue?vue&type=template&id=b70ccec4&scoped=true&"
import script from "./AppExamineDetail.vue?vue&type=script&lang=js&"
export * from "./AppExamineDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppExamineDetail.vue?vue&type=style&index=0&id=b70ccec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70ccec4",
  null
  
)

export default component.exports